import { useEffect, useState } from 'react';
import noop from 'lodash/noop';

type ImageStatus = 'error' | 'loading' | 'success';

function useImageWithFallback(src: string | null | undefined) {
  const [status, setStatus] = useState<ImageStatus>('loading');

  useEffect(() => {
    if (!src) {
      return;
    }

    setStatus('loading');

    let active = true;
    const image = new Image();

    image.onload = () => {
      if (!active) {
        return;
      }
      setStatus('success');
    };

    image.onerror = () => {
      if (!active) {
        return;
      }
      setStatus('error');
    };

    image.src = src;

    return () => {
      active = false;
    };
  }, [src]);

  const hasImg = Boolean(src);
  const hasImgNotFailing = hasImg && status !== 'error';

  return {
    hasImgNotFailing,
    onError: noop,
    onLoad: noop,
  };
}

export default useImageWithFallback;
